import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

export const Title = styled.h1`
  font-size: 4rem;
  line-height: 4rem;
  @media only screen and (max-width: ${BREAKPOINTS_LEGACY.xs}) {
    font-size: 2.625rem;
    line-height: 3.15rem;
  }
`;

export const LogoImage = styled.div`
  img {
    filter: invert(43%) sepia(30%) saturate(190%) hue-rotate(351deg) brightness(98%) contrast(87%);
  }
`;
